<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'invoices_download' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row pagination-box">
          <div class="col-xs-2">
            <a class="btn btn-info" target="_blank" href="/static/img/qb-csv-download.pdf">
              <i class="fa fa-cloud-download mr-5"></i>{{'csv_instructions' | translate}}
            </a>
          </div>
          <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        </div>
      </div>
      <div class="box-body">
        <invoicesTable :language="$store.getters.language" :items="pagination.data" @csv="downloadOrderList($event)"></invoicesTable>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
    <div class="overlay" v-show="loading">
      <img class="loading-gif" src="/static/img/blabla.svg"/>
    </div>
  </section>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
export default {
  name: 'Bills',
  data () {
    return {
      loading: false,
      startRange: moment().subtract(1, 'month'),
      endRange: moment(),
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      }
    }
  },
  components: {
    VueMonthlyPicker: VueMonthlyPicker
  },
  methods: {
    downloadOrderList (id) {
      this.loading = true
      let dataString
      let headerString
      API.get(`download/invoices/${id}/itemized`)
        .then(response => {
          let csvContent = 'data:text/csv;charset=utf-8,'
          response.body.forEach((infoArray, index) => {
            dataString = Object.keys(infoArray).map(k => {
              if (k === 'price' || k === 'fee' || k === 'additional_fee') {
                return infoArray[k] === null ? ' ' : `"${infoArray[k].toString().replace('.', ',')}"`
              } else {
                return infoArray[k] === null ? ' ' : `"${infoArray[k]}"`
              }
            }).join(',')
            if (index === 0) {
              headerString = Object.keys(infoArray).map(k => {
                return k
              }).join(',')
              csvContent += headerString + '\n'
            }
            csvContent += index < response.body.length ? dataString + '\n' : dataString
          })
          let encodedUri = encodeURI(csvContent)
          let link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', `Bills_${id}.csv`)
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get('download/invoices/archive')
          .then(response => {
            this.pagination = response.data
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .picker:not(.month-year-label) {
    background: #212228;
  }
  .picker > .flexbox:not(.monthItem) {
    background-color: rgba(0,195,150,.075);
    border-color: #00C396;
    color: #00C396;
    font-weight: 600;
  }
  .picker > .flexbox.monthItem {
    background-color: #212228 ;
    color: white;
    font-weight: 600;
    border-top: 1px solid rgba(255,255,255, .15) !important;
  }
  .picker .monthItem .item:hover {
    background-color: #00C396 !important;
  }
  .date-popover{
    background: none !important;
    border: 1px solid rgba(255,255,255, .15) !important
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/Bills.vue